import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ErrorResponse } from '../models/error.model';
import { SingleResultApiResponse } from '../models/api-response.model';

import { RegistrationService } from '../services/registration.service';
import { PreRegistrationModel } from '../models/pre-registration.model';
import { Store } from '@ngrx/store';
import {
  Action_StorePreRegistrationDetails,
  Action_StorePreRegistrationValidationResult,
  Action_SetGDPRCOMPLIANCE,
  Action_ClearPreRegistrationInfo
} from '../state/actions';
import { PreRegistrationValidationResult } from '../models/pre-registration-validation.result.model';
import { Country } from '../models/lookup-data.model';
import { LookupData } from 'src/app/shared/models/lookup-data.model';
import { FormService } from '../services/form.service';
import { AnyFn } from '@ngrx/store/src/selector';

@Component({
  selector: 'online-app-pre-registration',
  templateUrl: './pre-registration.component.html',
  styleUrls: ['./pre-registration.component.scss'],
  host: {
    class:'full-view-port-component-with-no-side-nav'
  }
})
export class PreRegistrationComponent implements OnInit {

  countries: Country[];
  nationalities: Country[];
  countriesOfResidence: Country[];
  selectedCountryErrorMessage: String = '';
  invalidDateOfBirthReason = '';
  preRegistrationValidationResult: PreRegistrationValidationResult;
  selectedRelationship1: LookupData;
  selectedRelationship2: LookupData;
  nationChosenErrorMsg: string;

  errorKeyFormFieldMapping = [
    { apiErrorKeyName: 'model', formFieldName: 'givenName', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'IsPastStudent', formFieldName: 'isPastStudent', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'GivenName', formFieldName: 'givenName', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'FamilyName', formFieldName: 'familyName', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'EmailAddress', formFieldName: 'emailAddress', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'DateOfBirth', formFieldName: 'dateOfBirth', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'CountryOfNationalityId', formFieldName: 'countryOfNationalityId', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'WillStudyForYearOrLess', formFieldName: 'willStudyForYearOrLess', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'Parent1GivenName', formFieldName: 'parent1GivenName', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'Parent1FamilyName', formFieldName: 'parent1FamilyName', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'Parent1Relationship', formFieldName: 'parent1Relationship', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'Parent2GivenName', formFieldName: 'parent2GivenName', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'Parent2FamilyName', formFieldName: 'parent2FamilyName', apiValidationErrorMsg: null },
    { apiErrorKeyName: 'Parent2Relationship', formFieldName: 'parent2Relationship', apiValidationErrorMsg: null },

  ];

  preRegistrationFormGroup: FormGroup;

  isFormSubmitted = false;
  isPastStudent: boolean = null;
  willStudyForYearOrLess: boolean = null;
  isValidStudent = false;
  // hasMandatoryFieldsEntered = false;

  studentOnlyHasOneName: boolean = null;
  parent1OnlyHasOneName: boolean = null;
  parent2OnlyHasOneName: boolean = null;

  singleParentOrGuardian: boolean = null;
  singleParentOrGuardianHasError: boolean = false;

  validationError: Boolean = false;
  isValidForStudyAbroad: boolean = true;

  constructor(private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private router: Router,
    private store: Store<any>,
    private formService: FormService,
    private registrationService: RegistrationService) {

    // this.configureJQuery();

    this.selectedRelationship1 = this.getDefaultRelationship();
    this.selectedRelationship2 = this.getDefaultRelationship();
  }


  ngOnInit() {

    this.countries = this.activatedRoute.snapshot.data['countries'];
    this.nationalities = this.countries.filter(c => c.Code !== 'AU' && c.Code !== 'NZ');
    this.countriesOfResidence = [...this.countries];


    this.studentOnlyHasOneName = false;
    this.parent1OnlyHasOneName = false;
    this.parent2OnlyHasOneName = false;
    this.singleParentOrGuardian = false;


    this.preRegistrationFormGroup = this.formBuilder.group({
      isPastStudent: ['', Validators.required],
      studentNumber: '',
      givenName: ['', Validators.required],
      familyName: ['', Validators.required],
      emailAddress: ['', [Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
      verifyEmailAddress: ['', [Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
      dateOfBirth: ['', Validators.required],
      countryOfNationalityId: ['', Validators.required],
      countryOfResidenceId: ['', [Validators.required]],
      willStudyForYearOrLess: ['', [Validators.required]],
      parent1GivenName: ['', Validators.required],
      parent1FamilyName: ['', Validators.required],
      parent1Relationship: ['', Validators.required],
      parent2GivenName: ['', Validators.required],
      parent2FamilyName: ['', Validators.required],
      parent2Relationship: ['', Validators.required],
    });

    // this.preRegistrationFormGroup.valueChanges.subscribe( formData => {
    //   //this.preRegistrationFormGroup = this.preRegistrationFormGroup.valid;
    //   this.preRegistrationFormGroup.updateValueAndValidity();
    // });

    this.clearPreRegistrationInfo();



  }

  givenNameUpdate(event: any) {
    if(this.preRegistrationFormGroup.get('givenName').value){
      this.preRegistrationFormGroup.get('givenName').setValue(this.titleCaseWord(this.preRegistrationFormGroup.get('givenName').value));
      this.preRegistrationFormGroup.updateValueAndValidity();
    }
  }

  familyNameUpdate(event: any) {
    if(this.preRegistrationFormGroup.get('familyName').value){
      this.preRegistrationFormGroup.get('familyName').setValue(this.preRegistrationFormGroup.get('familyName').value.toUpperCase());
      this.preRegistrationFormGroup.updateValueAndValidity();
    }
  }

  parent1GivenNameUpdate(event: any) {
    if(this.preRegistrationFormGroup.get('parent1GivenName').value){
      this.preRegistrationFormGroup.get('parent1GivenName').setValue(this.titleCaseWord(this.preRegistrationFormGroup.get('parent1GivenName').value));
      this.preRegistrationFormGroup.updateValueAndValidity();
    }
  }

  parent1FamilyNameUpdate(event: any) {
    if(this.preRegistrationFormGroup.get('parent1FamilyName').value){
      this.preRegistrationFormGroup.get('parent1FamilyName').setValue(this.preRegistrationFormGroup.get('parent1FamilyName').value.toUpperCase());
      this.preRegistrationFormGroup.updateValueAndValidity();
    }
  }

  parent2GivenNameUpdate(event: any) {
    if(this.preRegistrationFormGroup.get('parent2GivenName').value){
      this.preRegistrationFormGroup.get('parent2GivenName').setValue(this.titleCaseWord(this.preRegistrationFormGroup.get('parent2GivenName').value));
      this.preRegistrationFormGroup.updateValueAndValidity();
    }
  }

  parent2FamilyNameUpdate(event: any) {
    if(this.preRegistrationFormGroup.get('parent2FamilyName').value){
      this.preRegistrationFormGroup.get('parent2FamilyName').setValue(this.preRegistrationFormGroup.get('parent2FamilyName').value.toUpperCase());
      this.preRegistrationFormGroup.updateValueAndValidity();
    }
  }

  titleCaseWord(word: string) {
    if (!word) return word;
    return word[0].toUpperCase() + word.substr(1).toLowerCase();
  }

  getDefaultRelationship(): LookupData {
    return {
      Code: 'Please select',
      Description: 'Please select'
    };
  }

  get hasErrors(): boolean {
    return this.isFormSubmitted && Object.keys(this.preRegistrationFormGroup.controls).some(key => !!this.preRegistrationFormGroup.get(key).errors)
  };

  setPastStudent(isPastStudent: boolean): void {
    this.isPastStudent = isPastStudent;

    this.preRegistrationFormGroup.patchValue({
      isPastStudent: isPastStudent,
    });

    if (!isPastStudent) {
      this.preRegistrationFormGroup.patchValue({
        studentNumber: '',
      });

    }

    this.preRegistrationFormGroup.get('givenName').setErrors(null);

    this.preRegistrationFormGroup.updateValueAndValidity();
  }

  onStudentNumberChange(studentNumber: string) {

    if (this.preRegistrationFormGroup.get('givenName').errors &&
      this.preRegistrationFormGroup.get('givenName').errors.apiValidationError) {
      this.preRegistrationFormGroup.get('givenName').setErrors(null);
      this.preRegistrationFormGroup.updateValueAndValidity();
    }

  }

  isLargeErrorMessage(): boolean {
    const result = this.isFormSubmitted &&
      this.preRegistrationFormGroup.get('countryOfNationalityId').errors &&
      this.preRegistrationFormGroup.get('countryOfNationalityId').errors.apiValidationError &&
      this.getApiValidationErrorMsg('countryOfNationalityId').length <= 200;

    return result;
  }

  isLargerErrorMessage(): boolean {
    const result = this.isFormSubmitted &&
      this.preRegistrationFormGroup.get('countryOfNationalityId').errors &&
      this.preRegistrationFormGroup.get('countryOfNationalityId').errors.apiValidationError &&
      this.getApiValidationErrorMsg('countryOfNationalityId').length > 200;

    return result;
  }

  setWillStudyForYearOrLess(willStudyForYearOrLess: boolean) {
    this.willStudyForYearOrLess = willStudyForYearOrLess;

    this.preRegistrationFormGroup.patchValue({
      willStudyForYearOrLess: willStudyForYearOrLess,
    });
    this.preRegistrationFormGroup.updateValueAndValidity();

  }

  getApiValidationErrorMsg(formFieldName: string): string {
    const errorField = this.errorKeyFormFieldMapping
      .find(errorKeyFormField => errorKeyFormField.formFieldName === formFieldName &&
        errorKeyFormField.apiValidationErrorMsg);
    return errorField && errorField.apiValidationErrorMsg ? errorField.apiValidationErrorMsg : '';
  }

  getDateInISOString(dateObject: Date): string {
    const userTimezoneOffset = dateObject.getTimezoneOffset() * 60000;
    const date = new Date(dateObject.getTime() - userTimezoneOffset);
    return date.toISOString();
  }

  getDateInString(dateObject: Date): string {
    return `${dateObject.getDate()}/${dateObject.getMonth() + 1}/${dateObject.getFullYear()}`;
  }

  setDateOfBirth(dateObject: Date) {
    this.preRegistrationFormGroup.patchValue({
      dateOfBirth: dateObject,
    });
    this.preRegistrationFormGroup.updateValueAndValidity();
  }

  getDateFromString(dateInString: string): Date {
    const dateParts = dateInString.split('/');
    return new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]);
  }

  // configureJQuery() {

  //   const setDateOfBirth = this.setDateOfBirth.bind(this);

  //   $(function () {

  //     $('.datepicker-global').datepicker({
  //       dateFormat: 'dd/mm/yy',
  //       dayNamesMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  //       showOtherMonths: true,
  //       selectOtherMonths: true,
  //       firstDay: 1,
  //       beforeShow: function (textbox, instance) {
  //         $('.my-datepicker-global').append($('#ui-datepicker-div'));
  //       },
  //       onSelect: function () {

  //         const dateObject = $(this).datepicker('getDate');
  //         setDateOfBirth(dateObject);
  //       },
  //     });
  //   });
  // }


  getDate(fieldName: string): string {
    // const dateObject = new Date($(`#${fieldName}`).datepicker('getDate'));
    const dateObject = this.preRegistrationFormGroup.get(fieldName).value;
    const userTimezoneOffset = dateObject.getTimezoneOffset() * 60000;
    const date = new Date(dateObject.getTime() - userTimezoneOffset);
    return date.toISOString();
  }

  continueRegistration(): void {
    this.isFormSubmitted = true;
    this.nationChosenErrorMsg = "";
    const emailAddress = this.preRegistrationFormGroup.get('emailAddress').value;
    const verifyEmailAddress = this.preRegistrationFormGroup.get('verifyEmailAddress').value;

    if(emailAddress && verifyEmailAddress && emailAddress !== verifyEmailAddress) {
      this.preRegistrationFormGroup.get('verifyEmailAddress').setErrors({ 'notMatch': true });
    }


    const isPastStudent = this.preRegistrationFormGroup.get('isPastStudent').value;
    const studentNo = this.preRegistrationFormGroup.get('studentNumber').value;

    if (isPastStudent === null || isPastStudent === '') {
      this.preRegistrationFormGroup.get('isPastStudent').setErrors({ 'required': true });
    }
    else {
      this.preRegistrationFormGroup.get('isPastStudent').setErrors(null);
    }

    if (isPastStudent && studentNo.trim().length <= 0) {
      this.preRegistrationFormGroup.get('studentNumber').setErrors({ 'required': true });
    } else {
      this.preRegistrationFormGroup.get('studentNumber').setErrors(null);
    }

    



    //MN-349
    var parent1GivenNameControl = this.preRegistrationFormGroup.get('parent1GivenName');
    var parent2GivenNameControl = this.preRegistrationFormGroup.get('parent2GivenName');
    var parent1FamilyNameControl = this.preRegistrationFormGroup.get('parent1FamilyName');
    var parent2FamilyNameControl = this.preRegistrationFormGroup.get('parent2FamilyName');
    var parent1RelationshipControl = this.preRegistrationFormGroup.get('parent1Relationship');
    var parent2RelationshipControl = this.preRegistrationFormGroup.get('parent2Relationship');

    if (this.singleParentOrGuardian) {
      if (parent1GivenNameControl.value && parent2GivenNameControl.value) {
        this.singleParentOrGuardianHasError = true;
      }
      else {
        this.singleParentOrGuardianHasError = false;

        // if single parent, then we need to ignore 'given/family name missing' if there is
        if (parent1GivenNameControl.value && !parent2GivenNameControl.value) {
          parent2GivenNameControl.setValidators(null);
          parent2GivenNameControl.updateValueAndValidity();
          parent2FamilyNameControl.setValidators(null);
          parent2FamilyNameControl.updateValueAndValidity();
          parent2RelationshipControl.setValidators(null);
          parent2RelationshipControl.updateValueAndValidity();
        } else
          if (!parent1GivenNameControl.value && parent2GivenNameControl.value) {
            parent1GivenNameControl.setValidators(null);
            parent1GivenNameControl.updateValueAndValidity();
            parent1FamilyNameControl.setValidators(null);
            parent1FamilyNameControl.updateValueAndValidity();
            parent1RelationshipControl.setValidators(null);
            parent1RelationshipControl.updateValueAndValidity();
          }
      }
    }
    else {
      this.singleParentOrGuardianHasError = false;
    }

    setTimeout(() => {
      this.formService.scrollToFirstErrorField();
    }, 100);

    if (this.preRegistrationFormGroup.valid && !this.singleParentOrGuardianHasError) {
      // this.registerUser();
      const preRegistrationDetails = this.getPreRegistrationDetails();
      this.validatePreRegistrationStudentInfo(preRegistrationDetails);
    }

  }


  validatePreRegistrationStudentInfo(preRegistrationDetails: PreRegistrationModel) {
    this.isValidStudent = false;
    this.registrationService.validatePreRegistrationStudentDetails(preRegistrationDetails)
      .subscribe((response: SingleResultApiResponse) => {
        this.isValidStudent = true;
        this.preRegistrationValidationResult = response.Result as PreRegistrationValidationResult;

        //2020-04 Store later
        //this.storePreRegistrationDetails(preRegistrationDetails);
        //this.storePreRegistrationValidationResult(this.preRegistrationValidationResult);

        //// console.log('going to send below preRegistrationDetails')
        //// console.log(preRegistrationDetails);
        //// console.log('going to send below preRegistrationValidationResult')
        //// console.log(this.preRegistrationValidationResult);

        if (this.preRegistrationValidationResult.DoesStudentAlreadyExist) {
          preRegistrationDetails.StudentNumber = this.preRegistrationValidationResult.StudentNumber;

          //2020-04 If student number now starts with '1XXXXXC', then it is TISIM student!!
          if (preRegistrationDetails.StudentNumber.startsWith('1')) {
            console.log("TISIM Student!! --> ", preRegistrationDetails.StudentNumber);
            //alert("tisim student!!");
          }
          else {
            //student exist already and NOT TISIM student ...       
            console.log("student exist already but NOT TISIMS student");      
          }
        }
        else {
          console.log("Student does exist in ANT SYSTEM at all!");     
        }



        this.storePreRegistrationDetails(preRegistrationDetails);
        this.storePreRegistrationValidationResult(this.preRegistrationValidationResult);


        if (this.preRegistrationValidationResult && this.preRegistrationValidationResult.IsGdprRequired) {
          this.router.navigate(['/pre-registration-gdpr']);
        } else {
          this.setGDPRCompliance();
          this.router.navigate(['/account-registration']);
        }

      }, (error: ErrorResponse) => {
        const { errors } = error;

        //console.log('errors: ', errors);

        for (const errorKeyValue of errors) {
          this.setApiValidationError(errorKeyValue.Key, errorKeyValue.Value);
        }
        this.preRegistrationFormGroup.updateValueAndValidity();
        this.formService.scrollToFirstErrorField();
        //console.log('this.preRegistrationFormGroup: ', this.preRegistrationFormGroup);

      });
  }

  ValidateRegisteredWithSelectedNationality(countryOfNationalityId: string) {
    this.registrationService.ValidateRegisteredWithSelectedNationality(countryOfNationalityId)
      .subscribe((response: any) => {
        if(response){
          this.nationChosenErrorMsg = response.Result;
        }
      }, (error: ErrorResponse) => {
        const { errors } = error;

        // console.log('errors: ', errors);
        if(errors){
          for (const errorKeyValue of errors) {
            this.setApiValidationError(errorKeyValue.Key, errorKeyValue.Value);
          }
          this.preRegistrationFormGroup.updateValueAndValidity();
          this.formService.scrollToFirstErrorField();
        }
        
        //console.log('this.preRegistrationFormGroup: ', this.preRegistrationFormGroup);

      });
  }


  setApiValidationError(apiErrorKeyName: string, apiErrorMsg): void {
    //console.log(`apiErrorKeyName:${apiErrorKeyName},apiErrorMsg:${apiErrorMsg} `);
    const errorField = this.errorKeyFormFieldMapping.find(errorKeyFormField => errorKeyFormField.apiErrorKeyName === apiErrorKeyName);

    if (errorField) {
      const { formFieldName } = errorField;
      this.preRegistrationFormGroup.get(formFieldName).setErrors({ apiValidationError: true });
      errorField.apiValidationErrorMsg = apiErrorMsg;
    }

  }

  getPreRegistrationDetails(): PreRegistrationModel {

    const registrationDetails = new PreRegistrationModel();

    registrationDetails.StudentNumber = '';

    const isPastStudent = this.preRegistrationFormGroup.get('isPastStudent').value;

    if (isPastStudent) {
      registrationDetails.StudentNumber = this.preRegistrationFormGroup.get('studentNumber').value;
    }

    registrationDetails.GivenName = this.preRegistrationFormGroup.get('givenName').value;
    registrationDetails.FamilyName = this.preRegistrationFormGroup.get('familyName').value;
    registrationDetails.EmailAddress = this.preRegistrationFormGroup.get('emailAddress').value;
    registrationDetails.DateOfBirth = this.getDate('dateOfBirth');
    registrationDetails.CountryOfNationalityId = this.preRegistrationFormGroup.get('countryOfNationalityId').value;
    registrationDetails.CountryOfResidenceId = this.preRegistrationFormGroup.get('countryOfResidenceId').value;
    registrationDetails.WillStudyForYearOrLess = this.preRegistrationFormGroup.get('willStudyForYearOrLess').value;

    registrationDetails.Parent1GivenName =  this.preRegistrationFormGroup.get('parent1GivenName').value;
    registrationDetails.Parent1FamilyName = this.preRegistrationFormGroup.get('parent1FamilyName').value;
    registrationDetails.Parent1Relationship = this.preRegistrationFormGroup.get('parent1Relationship').value;

    registrationDetails.Parent2GivenName = this.preRegistrationFormGroup.get('parent2GivenName').value;
    registrationDetails.Parent2FamilyName = this.preRegistrationFormGroup.get('parent2FamilyName').value;
    registrationDetails.Parent2Relationship = this.preRegistrationFormGroup.get('parent2Relationship').value;
    
    if(this.preRegistrationFormGroup.get('parent1Relationship').value === 'Legal Custodian') {
      registrationDetails.LegalCustodianGivenName = this.preRegistrationFormGroup.get('parent1GivenName').value;
      registrationDetails.LegalCustodianFamilyName = this.preRegistrationFormGroup.get('parent1FamilyName').value;
    }

    registrationDetails.StudentOnlyHasOneName = this.studentOnlyHasOneName;
    registrationDetails.Parent1OnlyHasOneName = this.parent1OnlyHasOneName;
    registrationDetails.Parent2OnlyHasOneName = this.parent2OnlyHasOneName;
    registrationDetails.SingleParentOrGuardian = this.singleParentOrGuardian;

    return registrationDetails;
  }

  storePreRegistrationDetails(preRegistrationDetails: PreRegistrationModel) {

    //console.log('going to dispatch action - in storePreRegistrationDetails');

    this.store.dispatch({
      type: Action_StorePreRegistrationDetails,
      payload: preRegistrationDetails
    });
  }

  setGDPRCompliance(): void {
    this.store.dispatch({
      type: Action_SetGDPRCOMPLIANCE,
      payload: true
    });
  }

  storePreRegistrationValidationResult(preRegistrationValidationResult: PreRegistrationValidationResult) {

    //console.log('going to dispatch action - in storePreRegistrationValidationResult');

    this.store.dispatch({
      type: Action_StorePreRegistrationValidationResult,
      payload: preRegistrationValidationResult
    });
  }

  clearPreRegistrationInfo() {

    this.store.dispatch({
      type: Action_ClearPreRegistrationInfo
    });

  }

  cancel(): void {
    this.router.navigate(['/welcome-agent']);
  }


  isOnlyHasOneNameClicked(event, personEntity: string) {

    switch (personEntity) {

      case 'student': {
        this.studentOnlyHasOneName = event.checked;
        var onlyHasOneNameNewValue = this.studentOnlyHasOneName;
        this.studentOnlyHasOneName = onlyHasOneNameNewValue;

        const studentFamilyNameControl = this.preRegistrationFormGroup.get('familyName');
        if (onlyHasOneNameNewValue) {
          studentFamilyNameControl.setValidators(null);
          studentFamilyNameControl.setValue("");
        }
        else {
          studentFamilyNameControl.setValidators([Validators.required]);
        }

        studentFamilyNameControl.updateValueAndValidity();
        break;
      }


      case 'parent1': {
        this.parent1OnlyHasOneName = event.checked;
        var onlyHasOneNameNewValue = this.parent1OnlyHasOneName;
        this.parent1OnlyHasOneName = onlyHasOneNameNewValue;

        const parent1FamilyNameControl = this.preRegistrationFormGroup.get('parent1FamilyName');
        if (onlyHasOneNameNewValue) {
          parent1FamilyNameControl.setValidators(null);
          parent1FamilyNameControl.setValue("");
        }
        else {
          parent1FamilyNameControl.setValidators([Validators.required]);
        }

        parent1FamilyNameControl.updateValueAndValidity();
        break;
      }


      case 'parent2': {
        this.parent2OnlyHasOneName = event.checked;
        var onlyHasOneNameNewValue = this.parent2OnlyHasOneName;
        this.parent2OnlyHasOneName = onlyHasOneNameNewValue;

        const parent2FamilyNameControl = this.preRegistrationFormGroup.get('parent2FamilyName');
        if (onlyHasOneNameNewValue) {
          parent2FamilyNameControl.setValidators(null);
          parent2FamilyNameControl.setValue("");
        }
        else {
          parent2FamilyNameControl.setValidators([Validators.required]);
        }

        parent2FamilyNameControl.updateValueAndValidity();
        break;
      }

      default: {
        break;
      }
    }


    //Have to re-call !!
    this.preRegistrationFormGroup.updateValueAndValidity();


  }


  isSingleParentOrGuardianClicked(event) {
    this.singleParentOrGuardian = event.checked;

    if (this.singleParentOrGuardian) {
      var parent2GivenNameControl = this.preRegistrationFormGroup.get('parent2GivenName');
      var parent2FamilyNameControl = this.preRegistrationFormGroup.get('parent2FamilyName');
      parent2GivenNameControl.setValue(null);
      parent2FamilyNameControl.setValue(null);
    }
  }

  onNationalityCountrySelected(event: any) {

    const selectedCountry = this.countries.filter(c => c.Id == event.target.value)[0];
    const allowStudyAbroad = selectedCountry.CanStudyAbroad;

    this.isValidForStudyAbroad = allowStudyAbroad;

    if(this.preRegistrationFormGroup.get('countryOfNationalityId').value){
      this.ValidateRegisteredWithSelectedNationality(this.preRegistrationFormGroup.get('countryOfNationalityId').value);
    }
  }

  //show border when tab on link for accessibility
  linkTabAccessibility(event): void {
    event.style.outline = "1px solid black";
  }

  linkBlurAccessibility(event): void {
    event.style.outline = "";
  }

  //accessibility -- link error msg to form field
  errorDoubleErrorAccessibility(formControlName: string, requireErrorId: string, apiErrorId: string): string {
    if (this.isFormSubmitted &&
      this.preRegistrationFormGroup.get(formControlName).errors &&
      this.preRegistrationFormGroup.get(formControlName).errors.required) {
      return requireErrorId;
    } else if (this.isFormSubmitted &&
      this.preRegistrationFormGroup.get(formControlName).errors &&
      this.preRegistrationFormGroup.get(formControlName).errors.apiValidationError) {
      return apiErrorId;
    } else {
      return "";
    }
  }

  errorEmailErrorAccessibility(): string {
    if (this.isFormSubmitted &&
      this.preRegistrationFormGroup.get("emailAddress").errors &&
      this.preRegistrationFormGroup.get("emailAddress").errors.required) {
      return "requiredEmail";
    } else if (this.isFormSubmitted &&
      this.preRegistrationFormGroup.get("emailAddress").errors &&
      this.preRegistrationFormGroup.get("emailAddress").errors.apiValidationError) {
      return "apiErrorEmail";
    } else if (this.isFormSubmitted &&
      this.preRegistrationFormGroup.get('emailAddress').errors &&
      this.preRegistrationFormGroup.get('emailAddress').errors.email) {
      return "errorEmail";
    }else {
      return "";
    }
  }

  errorVerifyEmailAddressAccessibility(): string {
    if (this.isFormSubmitted &&
      this.preRegistrationFormGroup.get("verifyEmailAddress").errors &&
      this.preRegistrationFormGroup.get("verifyEmailAddress").errors.required) {
      return "requiredEmail";
    } else if (this.isFormSubmitted &&
      this.preRegistrationFormGroup.get('verifyEmailAddress').errors &&
      this.preRegistrationFormGroup.get('verifyEmailAddress').errors.email) {
      return "errorEmail";
    }else if (this.isFormSubmitted &&
      this.preRegistrationFormGroup.get('verifyEmailAddress').errors &&
      this.preRegistrationFormGroup.get('verifyEmailAddress').errors.notMatch) {
      return "apiErrorEmail";
    }
    else {
      return "";
    }
  }

  keyboardFocus(event): void {
    event.style.outline = "1px solid blue";
  }

  keyboardBlur(event): void {
    event.style.outline = "";
  }
}

